module.exports = __webpack_public_path__ + "img/qr.b0726c46.svg";